<template>
  <div class="vue-spinner" role="status" aria-label="Laddar..."></div>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>

<style scoped>
.vue-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: vue-spin 0.75s linear infinite;
  color: #62269e; /* @uhrcolor-lila — UHR brand purple */
}

@keyframes vue-spin {
  to { transform: rotate(360deg); }
}
</style>
